import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import ArrowLeftIconSvg from './icon-arrow-left.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <ArrowLeftIconSvg {...validProps} />;
}
SvgComponent.iconName = 'arrowLeftIcon';

export const ArrowLeftIcon = svgIconWrapper(SvgComponent);
